<template>
	<div class="header-one">
    <div class="" @touchmove.prevent>
        <div class="disflex" style="justify-content: space-between;">
          <a class="" href="/"><img width="60" src="static/images/home.png" /></a>
          <div class="disflex" style="justify-content: flex-end;">
            <div class="header-score disflex"><img src="../../static/images/pt-icon.png"><div class="ac w100"> {{info.points}}</div></div>
          </div>
        </div>
    </div>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
      props: ['message'],
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              info:{}
            }
        },
        created(){
          if(localStorage.getItem('lang')){
            this.isShowLang = localStorage.getItem('lang')
          }
          this.getInfo()
        },
		methods: {
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      getInfo (){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/info',null,r =>{
        	that.$parent.$parent.returnCode(r,function(){
            that.info = r.data
            localStorage.setItem('info',r.data.score)
            localStorage.setItem('int_url',r.data.invite_url)
            that.$parent.$parent.loadModal(false);
          });
        })
      }
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/HeaderOne.vue